import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FormFeedback } from "reactstrap";

interface DatepickerProps {
  name: string;
  selectedDate: Date | null;
  onChange: (name: string, value: Date | null) => void;
  placeholder?: string;
  dateFormat?: string;
  isDisabled?: boolean;
  error?: string;
  minDate?: Date;
}

const Datepicker: React.FC<DatepickerProps> = ({
  name,
  selectedDate,
  onChange,
  placeholder = "Select",
  dateFormat = "dd/MM/yyyy",
  isDisabled = false,
  error = "",
  minDate,
}) => {
  return (
    <div style={{ width: "100%" }}>
      <DatePicker
        name={name}
        selected={selectedDate}
        onChange={(value: Date | null) => {
          if (!isDisabled) {
            onChange(name, value);
          }
        }}
        dateFormat={dateFormat}
        className={`form-control ${!isDisabled && "cursor-pointer"}  ${
          error ? "is-invalid" : ""
        }`}
        wrapperClassName="w-100"
        placeholderText={placeholder}
        disabled={isDisabled}
        minDate={minDate}
      />
      {error && (
        <FormFeedback type="invalid" className="d-block">
          {error}
        </FormFeedback>
      )}
    </div>
  );
};

export default Datepicker;
